import { Box, Button, Typography } from '@mui/material'
import CustomDialog from '../CustomDialog'
import { AssignDiscipline } from '../../models/Review'

interface ConfirmReassignProps {
  isOpen: boolean
  discipline: AssignDiscipline
  handleSubmit: (disciplineId: number | undefined) => void
  handleClose: () => void
}

const ConfirmReassignComponent: React.FC<ConfirmReassignProps> = ({
  isOpen,
  discipline,
  handleSubmit,
  handleClose,
}) => {
  return (
    <CustomDialog
      isOpen={isOpen}
      title=''
      handleSubmit={handleSubmit}
      handleClose={handleClose}
      hideActions={true}
    >
      <Box
        gap='1.5rem'
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '17rem',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          sx={{
            color: '#797979',
            fontSize: '0.7rem',
            fontWeight: 500,
            lineHeight: 'normal',
            textAlign: 'center',
          }}
        >
          Please confirm you want to reassign this project to another engineer.
          This means the process will start over and the request is sent to the
          Admin.
        </Typography>
        <Box gap='0.75rem' display='flex'>
          <Button
            variant='outlined'
            onClick={() => handleClose()}
            sx={{
              color: '#56003D',
              background: '#fff',
              border: '1px solid #56003D',
              fontSize: '0.64rem',
              textTransform: 'none',
              height: '1.5rem',
            }}
          >
            No, go back
          </Button>
          <Button
            variant='contained'
            onClick={() => handleSubmit(discipline.id)}
            sx={{
              color: '#fff',
              background: '#56003D',
              fontSize: '0.64rem',
              textTransform: 'none',
              height: '1.5rem',
            }}
          >
            Yes, Reassign
          </Button>
        </Box>
      </Box>
    </CustomDialog>
  )
}

export default ConfirmReassignComponent
